module.exports = __webpack_public_path__ + "462bd8bb88b59e17890e53e7b4b286b2.jpg";